export const WeatherConditions = {
  // TODO: https://jira.kindredgroup.com/browse/PMAR-1326
  // the exact strings for weather conditions we will get from API are unclear yet
  CLEAR_SKY: 'Clear Sky',
  RAINY: 'Rainy',
  CLOUDY: 'Cloudy',
  WINDY: 'Windy',
} as const;
